module.exports = __webpack_public_path__ + "media/images/la reunion-852bff46e65d862d4d6bfe57d7a65943.svg";